import { useState, useEffect, useMemo } from 'react';
import { useMsal } from '@azure/msal-react';
// import TabList from '../TabList'; // Ensure you have the correct import path
import KPIService from '../../services/console_services/KPI';
import MapService from '../../services/console_services/Map';
import useTabList from '../TabList';
import UserDetailsServices from '../../services/console_services/LoginLogot';

// Hook to check access based on localStorage
const checkAccess = (moduleName) => {
  const userDetailsString = localStorage.getItem('userDetails');
  const userDetails = userDetailsString ? JSON.parse(userDetailsString) : { AccessDetails: [] };

  return userDetails.AccessDetails?.some(accessDetail => accessDetail.ModuleName === moduleName) || false;
};

// Hook to manage fetching data and handling logic for SNO component
const useSNOTabs = ({
  tabIndex,
  role,
  applyFilter,
  DC,
  Network,
  PL3,
  Division,
  Products,
  date,
  periodType,
}) => {
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(true);
  const [mapData, setMapData] = useState([]);
  const [MapLoading, setMapLoading] = useState(false);
  const TabList = useTabList();
  const { instance } = useMsal();
  // Memoize the current tab data
  const currentTabData = useMemo(() => TabList["SNO_DOM_RR"][tabIndex], [tabIndex]);
  useEffect(() => {
    const fetchMapData = async () => {
      const params = {
        name: currentTabData?.value,
        Level: role,
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          Products,
          startDate: date[0],
          endDate: date[1],
        },
      };
      setMapLoading(true);
      MapService.getMAP(params, instance).then(data => {
        if (data?.data) {
          setMapData(data?.data);
        }
      })
        .catch(error => console.error('Error:', error))
        .finally(() => setMapLoading(false));
    };
    fetchCreateAlertsWithUser();
    fetchMapData();
  }, [currentTabData, role, applyFilter, DC, Network, PL3, Division, Products, date]);



  const fetchCreateAlertsWithUser = () => {
    if (currentTabData?.value) {
      UserDetailsServices.createAlertsWithUser({
        module: currentTabData?.value
      }, instance);
      UserDetailsServices.createAlertsWithThresholdUser({
        module: currentTabData?.value
      }, instance);
    }
  };

  useEffect(() => {
    const fetchKPIData = async () => {
      const params = {
        name: currentTabData?.value,
        periodType,
        Level: role,
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          MaterialID: Products,
          startDate: date[0],
          endDate: date[1],
        },
      };

      setKPILoading(true);
      KPIService.getKPI(params, instance).then(data => {
        if (data?.response) {
          setKPIData(data?.response);
        }
      })
        .catch(error => console.error('Error:', error))
        .finally(() => setKPILoading(false));
    };

    fetchKPIData();
  }, [currentTabData, periodType, role, applyFilter, DC, Network, PL3, Division, Products, date]);

  return {
    KPIData,
    KPILoading,
    mapData,
    MapLoading,
    currentTabData,
  };
};

export { checkAccess, useSNOTabs };